import { render } from "./EventRule.vue?vue&type=template&id=0354a8f8&scoped=true"
import script from "./EventRule.vue?vue&type=script&lang=js"
export * from "./EventRule.vue?vue&type=script&lang=js"

import "./EventRule.vue?vue&type=style&index=0&id=0354a8f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0354a8f8"],['__file',"src/containers/event/eventSettings/components/EventRule.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0354a8f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0354a8f8', __exports__)) {
    api.reload('0354a8f8', __exports__)
  }
  
  module.hot.accept("./EventRule.vue?vue&type=template&id=0354a8f8&scoped=true", () => {
    api.rerender('0354a8f8', render)
  })

}


export default __exports__